<template>
  <div data-component="basket-component">
    <section data-element="basket-listing">
      <div data-element="basket-header">
        <icon
          tabindex="0"
          data-element="icon"
          icon="arrow-left"
          @click.native="$router.go(-1)"
        />
        <h3
          data-element="basket-heading"
          v-font-style="this.$store.getters['ui/getHeadingFontDetail']"
          v-color="this.$store.getters['ui/getPrimaryColor']"
          v-modify-leading="this.$store.getters['ui/getHeadingFontDetail']"
        >
          Your basket
        </h3>
      </div>
      <div
        v-if="basket.lines.length"
        data-element="basket-and-checkout-btn-container"
      >
        <div data-element="basket">
          <line-item
            :getProduct="getProduct"
            v-for="lineItem in basket.lines"
            :key="lineItem.basketKey"
            :lineItem="lineItem"
            :removeItemFromBasket="removeItemFromBasket"
            :getBasketIndex="getBasketIndex"
            :displayProduct="getDisplayProduct(lineItem)"
            :editBasketChoices="editBasketChoices"
            :choiceGroups="getChoiceGroups(lineItem)"
            :getCG="getCG"
            :cgIndex="cgIndex"
            :incrementBasketItem="incrementBasketItem"
            :decrementBasketItem="decrementBasketItem"
            :unavailable="lineItem.unavailable"
          />
        </div>
        <sticky-footer data-element="sticky-footer">
          <!-- <voucher-input
            data-element="voucher-input"
            :mobile="true"
            :submitVoucher="submitVoucher"
            :checkingVoucher="checkingVoucher"
            :voucherApplied="voucherApplied"
            /> -->
          <checkout-btn
            :handleClick="placeOrder"
            :basketTotal="basketTotal"
            :basketCount="basketCount"
            :loading="checkingOrder"
            :inactive="!basketCount"
            containerSize="md"
            text="Pay now"
          />
        </sticky-footer>
      </div>

      <div data-element="empty-basket" v-else>
        <p
          data-element="text"
          v-font-style="
            this.$store.getters['ui/getBodyCopyFontDetail']('normal')
          "
          :style="{ fontSize: `16px` }"
        >
          You have no items in your basket
        </p>
      </div>
    </section>
    <transition name="fade-in" appear>
      <IOrderCheckoutModal
        :success="handleCheckoutSuccess"
        :failure="handleCheckoutFailure"
        headertext="Text goes here"
        :salesData="salesData"
        :serviceid="serviceId"
        :applicationName="`${applicationName}`"
        location="Location text"
        alertsCode="coat"
        :guestLoginCallback="handleGuestLogin"
        :hideAlcoholNotice="hideAlcoholNotice"
      />
    </transition>
  </div>
</template>

<script>
import IOrderCheckoutModal from "@/components/checkout/IorderCheckoutModal.vue";
// import VoucherInput           from '@/components/basket/VoucherInput';
import menuAndBasket from "@/mixins/menuAndBasket";
import CheckoutBtn from "@/components/ui/CheckoutBtn";
import StickyFooter from "@/components/ui/StickyFooter";
import Icon from "@/components/ui/Icon";
import LineItem from "@/components/basket/LineItem";

export default {
  components: {
    IOrderCheckoutModal,
    // VoucherInput,
    Icon,
    LineItem,
    StickyFooter,
    CheckoutBtn,
  },
  mixins: [menuAndBasket],
  props: ["content", "hideAlcoholNotice"],
  data() {
    return {
      loaded: null,
      checkingOrder: null,
      checkingVoucher: null,
      showModal: null,
    };
  },
  computed: {
    availableTimeslots() {
      return this.$store.getters["iOrderCore/getAvailableTimeslots"];
    },
    alternativeTimeslots() {
      return this.$store.getters["iOrderCore/getAlternativeTimeslots"];
    },
    appSlug() {
      if (this.app === "clickAndCollect") {
        return "takeaway";
      } else if (this.app === "orderAhead") {
        return "order-ahead";
      } else {
        return null;
      }
    },
    applicationName() {
      if (this.app === "clickAndCollect") {
        return "Click & Collect";
      } else if (this.app === "orderAhead") {
        return "Order Ahead";
      } else {
        return null;
      }
    },
    promotionDiscount() {
      return Math.abs(
        this.$store.getters["iOrderCheckout/getPromotionDiscountAmount"]
      );
    },
    voucherDiscount() {
      return Math.abs(
        this.$store.getters["iOrderCheckout/getVoucherDiscountAmount"]
      );
    },
    discountedTotal() {
      return (this.basketTotal - this.voucherDiscount).toFixed(2);
    },
    locationSlug() {
      return (
        this.$store.getters["iOrderCore/getLocation"] &&
        this.$store.getters["iOrderCore/getLocation"].slug
      );
    },
    salesData() {
      return this.$store.getters["iOrderCore/getRequiredSalesData"];
    },
    serviceId() {
      return this.salesData.serviceId;
    },
    timeslot() {
      return this.$store.getters["iOrderCore/getTimeslot"];
    },
    voucherApplied() {
      if (this.$store.getters["iOrderCore/getValidVoucherApplied"]) {
        return {
          detail: this.$store.getters["iOrderCore/getValidVoucherApplied"],
          code: this.$store.getters["iOrderCore/getVoucher"].voucherCode,
        };
      } else {
        return null;
      }
    },
  },
  methods: {
    closeModal() {
      document.body.removeAttribute("data-modal");
      document.documentElement.removeAttribute("data-modal");
      this.showModal = false;
    },
    getChoiceGroups(lineItem) {
      return this.$store.getters["iOrderCore/getChoices"](
        lineItem.ingredientId
      );
    },
    getDisplayProduct(lineItem) {
      return this.$store.getters["iOrderCore/getDisplayItem"](
        lineItem.ingredientId
      );
    },
    goBack() {
      this.$router.go(-1);
    },
    async handleCheckoutSuccess() {
      await this.$store.dispatch("iOrderCheckout/submitEcomTracking", {
        affiliation: this.$store.getters["getBrandName"],
        env: this.$store.state.iOrderCore.env,
      });
      this.loaded = false;
      this.$store.dispatch("iOrderCheckout/fetchOrderNumber");
      this.$store.dispatch("iOrderCheckout/hideModal");
      this.$router.push("success");
    },
    handleCheckoutFailure() {
      this.$store.dispatch("iOrderCheckout/hideModal");
      this.$router.push("failure");
    },
    handleGuestLogin() {
      this.$store.dispatch("iOrderCheckout/showCheckoutModal");
    },
    // async checkBasketValidity () {
    //   const basket = await this.$store.dispatch('iOrderCheckout/checkBasket', {
    //     siteId: this.$store.state.iOrderCore.requiredSalesData.siteId,
    //     salesAreaId: this.$store.state.iOrderCore.requiredSalesData.salesAreaId,
    //     serviceId: this.$store.state.iOrderCore.requiredSalesData.serviceId,
    //     basketLines: this.$store.state.iOrderCore.basket.lines,
    //     voucherLines: this.$store.state.iOrderCore.basket.voucherLines,
    //     user: this.$store.getters['iOrderCheckout/getCurrentUser'],
    //     timeslot: this.$store.state.iOrderCore.requiredSalesData.timeslot
    //   })
    //
    //   if (basket.success) {
    //     return
    //   }
    //   if (basket.status === 'unavailableLines') {
    //     this.$store.dispatch('iOrderCore/markItemsUnavailable', { productId: basket.ingredientId });
    //     return
    //   }
    //   if (basket.status === 'timeslotUnavailable') {
    //     const timeslotsAvailable = await this.$store.dispatch['iOrderCore/validateTimeslots'];
    //     this.showModal = 'alternativeTimesModal';
    //     return
    //   }
    //   if (basket.status) {
    //     this.$store.dispatch('iOrderCore/showError', { heading: 'Error', message: basket.status })
    //     return
    //   }
    //
    //   this.$store.dispatch('iOrderCore/showError', { heading: 'Error', message: 'Unknown error' })
    //
    // },
    async setNextAvailableTimeslot() {
      const siteId = this.$store.getters["clickAndCollect/getZonalSiteId"];
      const timeslots = await this.$store.dispatch(
        "clickAndCollect/validateTimeslots",
        { siteId }
      );

      if (timeslots) this.$store.dispatch("clickAndCollect/setNextTimeslot");
    },
    // async initBasket () {
    //   this.checkBasketValidity();
    // },
    async placeOrder() {
      this.checkingOrder = true;

      this.$store.dispatch("iOrderCore/setTillMessage");

      const basket = await this.$store.dispatch("iOrderCheckout/checkBasket", {
        siteId: this.$store.state.iOrderCore.requiredSalesData.siteId,
        salesAreaId: this.$store.state.iOrderCore.requiredSalesData.salesAreaId,
        serviceId: this.$store.state.iOrderCore.requiredSalesData.serviceId,
        basketLines: this.$store.state.iOrderCore.basket.lines,
        voucherLines: this.$store.state.iOrderCore.basket.voucherLines,
        user: this.$store.getters["iOrderCheckout/getCurrentUser"],
        timeslot: this.$store.state.iOrderCore.requiredSalesData.timeslot,
      });

      if (basket.success) {
        this.checkingOrder = false;
        this.$store.dispatch("iOrderCheckout/showGuestLoginModal");
        return;
      }
      if (basket.status === "unavailableLines") {
        this.checkingOrder = false;
        this.$store.dispatch("iOrderCore/markItemsUnavailable", {
          productId: basket.ingredientId,
        });
        return;
      }
      if (basket.status === "timeslotUnavailable") {
        const timeslotsAvailable = await this.$store.dispatch[
          "iOrderCore/validateTimeslots"
        ];
        this.showModal = "alternativeTimesModal";
        this.checkingOrder = false;
        return;
      }
      if (basket.status) {
        this.$store.dispatch("iOrderCore/showError", {
          heading: "Error",
          message: basket.status,
        });
        this.checkingOrder = false;
        return;
      }

      this.$store.dispatch("iOrderCore/showError", {
        heading: "Error",
        message: "Unknown error",
      });
      this.checkingOrder = false;
    },
    async submitVoucher(voucherCode) {
      this.checkingVoucher = true;

      const voucher = await this.$store.dispatch(
        "iOrderCheckout/checkVoucher",
        {
          siteId: this.$store.state.iOrderCore.requiredSalesData.siteId,
          salesAreaId: this.$store.state.iOrderCore.requiredSalesData
            .salesAreaId,
          voucherCode: voucherCode,
          identifier: `Web - iOrderCore`,
        }
      );

      if (voucher.success) {
        this.$store.dispatch("iOrderCore/applyVoucher", {
          voucherCode: voucher.voucherCode,
        });

        const basket = await this.$store.dispatch(
          "iOrderCheckout/checkBasket",
          {
            siteId: this.$store.state.iOrderCore.requiredSalesData.siteId,
            salesAreaId: this.$store.state.iOrderCore.requiredSalesData
              .salesAreaId,
            serviceId: this.$store.state.iOrderCore.requiredSalesData.serviceId,
            basketLines: this.$store.state.iOrderCore.basket.lines,
            voucherLines: this.$store.state.iOrderCore.basket.voucherLines,
            user: this.$store.getters["iOrderCheckout/getCurrentUser"],
            timeslot: this.$store.state.iOrderCore.requiredSalesData.timeslot,
          }
        );

        if (basket.success) {
          this.checkingVoucher = false;
          const voucherDescription = this.$store.getters[
            "iOrderCheckout/getVoucherDetail"
          ].voucher.metaData.friendlyName;
          this.$store.dispatch("iOrderCore/setVoucherDescription", {
            voucherDescription,
          });
          return;
        }

        this.$store.dispatch("iOrderCore/clearVoucher");
        this.checkingVoucher = false;

        if (basket.status === "timeslotUnavailable") {
          const timeslotsAvailable = await this.$store.dispatch[
            "iOrderCore/validateTimeslots"
          ];
          this.showModal = "alternativeTimesModal";
          return;
        }
        if (basket.status === "voucherError") {
          this.$store.dispatch("iOrderCheckout/showToast", {
            detail:
              "This voucher could not be applied to your basket. Please try again.",
            size: "small",
          });
          return;
        }
        if (basket.status) {
          this.$store.dispatch("iOrderCheckout/showToast", {
            detail: basket.status,
            size: "small",
          });
          return;
        }
        this.$store.dispatch("iOrderCheckout/showToast", {
          detail: "Oops, an error has occurred. Please try again.",
          size: "small",
        });
      }

      this.$store.dispatch["iOrderCore/clearVoucher"];
      this.checkingVoucher = false;

      if (voucher.status === "invalidVoucherCode") {
        this.$store.dispatch("iOrderCheckout/showToast", {
          detail:
            "This voucher code is not valid. Please try a different voucher code.",
          size: "small",
        });
        return;
      }

      if (voucher.status) {
        this.$store.dispatch("iOrderCheckout/showToast", {
          detail: voucher.status,
          size: "small",
        });
        return;
      }

      this.$store.dispatch("iOrderCheckout/showToast", {
        detail: "Oops, an error has occurred. Please try again.",
        size: "small",
      });
    },
    removeItemFromBasket(lineItem) {
      this.$store.dispatch("iOrderCore/removeItemFromBasket", { lineItem });
    },
    setTimeslot(timeslot) {
      this.$store.commit("iOrderCore/setTimeslot", { timeslot });
    },
  },
  // created () {
  //   this.initBasket();
  // },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
@import "@/assets/scss/helpers.scss";

[data-component="basket-component"] {
  width: 100%;
  display: flex;
  flex-direction: row;
  max-width: 456px;
  [data-element="basket-listing"] {
    width: 100%;
    @include whenScreenIs(md) {
      width: 529px;
      margin-left: 67px;
    }
    [data-element="basket-and-checkout-btn-container"] {
      width: 100%;
    }
    [data-element="basket-header"] {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      @include whenScreenIs(md) {
        justify-content: flex-start;
      }
      [data-element="icon"] {
        position: absolute;
        top: 12px;
        left: 16px;
        -webkit-tap-highlight-color: transparent;
        &:focus {
          outline-color: #fff;
        }
        @include clickable(true);
        @include whenScreenIs(md) {
          top: 40px;
        }
      }
      [data-element="basket-heading"] {
        font-size: 20px;
        text-align: center;
        padding: 16px;
        @include whenScreenIs(md) {
          text-align: left;
          margin: 24px 0 0 73px;
          padding-left: 0;
        }
      }
    }
    [data-element="payment-discount-mobile"] {
      @include whenScreenIs(md) {
        display: none;
      }
    }
    [data-element="timeslot-display"] {
      margin: 16px;
      @include whenScreenIs(md) {
        margin: 16px 0 0 73px;
      }
    }
    [data-element="basket"] {
      margin: 0 16px 170px;
      @include whenScreenIs(md) {
        background-color: $white;
        margin: 24px 0 0 73px;
      }
    }
    [data-element="empty-basket"] {
      [data-element="text"] {
        text-align: center;
        font-weight: 900;
        margin: 30px 0;
      }
    }
    [data-element="sticky-footer"] {
      display: flex;
      flex-direction: column;
      @include whenScreenIs(md) {
        display: none;
      }
    }
  }
}
</style>
